import React from "react";
import PropTypes from "prop-types";

/**
 * Small "BETA" badge surfaced under (or as a corner pill on) experimental
 * controls — currently Workflow + Suggestions in the top nav and the
 * Interactive Elements rail title.
 *
 * Purely presentational; positioning is the caller's responsibility (the
 * caller wraps it in whatever absolute/relative container makes sense for
 * its layout). Inline styles match the Studio palette (primary tint
 * #B766FA, same accent the WorkflowButton uses for its active state) and
 * sit at 11px to stay visually subordinate to the labelled control.
 */
function BetaBadge({ className, style }) {
  const baseStyle = {
    display: "inline-block",
    fontSize: 9,
    lineHeight: 1,
    fontWeight: 700,
    letterSpacing: 0.5,
    padding: "2px 5px",
    borderRadius: 6,
    backgroundColor: "#B766FA",
    color: "#FFFFFF",
    textTransform: "uppercase",
    userSelect: "none",
    pointerEvents: "none",
  };
  return (
    <span
      data-testid="beta-badge"
      className={className ? `beta-badge ${className}` : "beta-badge"}
      style={{ ...baseStyle, ...(style || {}) }}
    >
      BETA
    </span>
  );
}

BetaBadge.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};

export default BetaBadge;
